var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectedSlot = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "selectedSlot_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.8,
  stroke: "#5555E7",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 6,
  fill: "#5555E7"
})));
export default SvgSelectedSlot;